import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Patient, PatientConsent } from 'backend/interfaces/patient.interface';
import { Observable } from 'rxjs';
import {BreakpointObserver} from '@angular/cdk/layout';
import {MatStepper, StepperOrientation} from '@angular/material/stepper';
import {map} from 'rxjs/operators';
import { PatientService } from 'src/app/admin/services/patient.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  @Input() profile: Patient = {
    Name: '',
    Surname: '',
    ID: '',
    Occupation: '',
    Title: '',
    Gender: '',
    Address: '',
    Mobile: '',
    Email: this.patientService.newPatientEmail ? this.patientService.newPatientEmail : '',
    ReferredBy: '',
    HealthProblems: '',
    Notes: '',
    MedicalAidName: '',
    MedicalAidNumber: '',
    MedicalAidMainMember: ''
  };
  saving = false;
  @Output() emitProfile: EventEmitter<any> = new EventEmitter();
  @Output() emitMedical = new EventEmitter<Object>();
  @ViewChild('stepper') private stepper: MatStepper;
  constructor(private fb: UntypedFormBuilder, private breakpointObserver: BreakpointObserver, private patientService: PatientService, private router: Router, private _snackBar: MatSnackBar) {
    this.stepperOrientation = breakpointObserver.observe('(min-width: 800px)')
      .pipe(map(({matches}) => matches ? 'horizontal' : 'vertical'));
  }
  profileForm: UntypedFormGroup;
  medicalForm: UntypedFormGroup;
  thirdFormGroup = this.fb.group({
    thirdCtrl: ['', Validators.required]
  });
  stepperOrientation: Observable<StepperOrientation>;
  ngOnInit(): void {
    this.profileForm = this.fb.group({
      Name: [this.profile.Name, Validators.required],
      Surname: [this.profile.Surname, Validators.required],
      ID: [this.profile.ID, Validators.required, Validators.length > 6],
      Occupation: [this.profile.Occupation, Validators.required],
      Title: [this.profile.Title, Validators.required],
      Gender: [this.profile.Gender, Validators.required],
      Address: [this.profile.Address, Validators.required],
      Mobile: [this.profile.Mobile, Validators.required],
      Email: [this.profile.Email, Validators.required]});
    this.medicalForm = this.fb.group({
      ReferredBy: [this.profile.ReferredBy],
      HealthProblems: [this.profile.HealthProblems, Validators.required],
      Notes: [this.profile.Notes],
      MedicalAidName: [this.profile.MedicalAidName, Validators.required],
      MedicalAidNumber: [this.profile.MedicalAidNumber, Validators.required],
      MedicalAidMainMember: [this.profile.MedicalAidMainMember, Validators.required]
    });
  }
  async saveProfile(){
    if(this.profileForm.dirty){
      this.saving = true;
      this.patientService
      .savePatient(this.profileForm.value)
      .then((res) => {
        this.saving = false;
        this.patientService.newPatientEmail = undefined;
        this.openSnackBar('Patient saved');
        this.stepper.next();
        this.patientService.getPatientCount();
      })
      .catch((err) => {
        this.openSnackBar(err);
        this.saving = false;
      });
      this.profileForm.markAsPristine();
      this.profile.ID = this.profileForm.controls['ID'].value;
    } else {
      this.stepper.next();
    }
  }
  async saveMedicalDetails(){
    if(this.medicalForm.dirty){
      this.saving = true;
      const medicalForm = {...this.medicalForm.value, 
        ID: this.profile.ID};

        this.patientService
        .savePatientMedicalDetails(medicalForm)
        .then(() => {
          this.openSnackBar('Medical details saved');
          this.saving = false;
          this.stepper.next();
        })
        .catch((err) => {
          this.openSnackBar(err);
          this.saving = false;
        });
      this.medicalForm.markAsPristine();
    } else {
      this.stepper.next();
    }
  }
  getErrorMessage() {
    if (this.profileForm.controls['Name'].hasError('required')) {
      return 'You must enter a value';
    }
  
    return this.profileForm.controls['Name'].hasError('required') ? 'Not a valid name' : '';
  }

  async savePatientConsent(event: {patient: PatientConsent, signature: string}){
    this.patientService
      .savePatientConsent(event.patient)
      .then(() => {
        this.openSnackBar('Patient consent saved');
        this.saving = false;
        this.emitProfile.emit(event.patient);
      })
      .catch((err) => {
        this.openSnackBar(err);
        this.saving = false;
      });
    this.saving = false;
  }


  back(){
    this.stepper.previous();
  }

  openSnackBar(message: string) {
    this._snackBar.open(message, 'OK', {
      duration: 3000
    });
  }
}



